import React from "react";
import styles from "./StoryCard.module.scss";

export default function StoryCard({
  title,
  description,
  image,
  backgroundColor,
  marginTop
}) {
  return (
    <div className={styles.card} style={{ marginTop }}>
      <div className={styles.cardContent} style={{ backgroundColor }}>
        <div className={styles.cardInfo}>
          <h2 className={styles.title}>{title}</h2>
          <p className={styles.description}>{description}</p>
          <button className={styles.playButton}>
            <div className={styles.playButtonContent}>
              <div className={styles.playText}>Play</div>
              <img
                src="https://cdn.builder.io/api/v1/image/assets/TEMP/f0e8ef7b19ab39f796f89ca427de513b03ea93ee4869befa25d078bfc7dc26c4?placeholderIfAbsent=true&apiKey=b8d7041a24ed4a8e80433853cda3ec05"
                alt=""
                className={styles.playIcon}
                loading="lazy"
              />
            </div>
          </button>
        </div>
        <img
          src={image}
          alt={title}
          className={styles.storyImage}
          loading="lazy"
        />
      </div>
    </div>
  );
}
